import React from 'react'
import { IconButton, InputAdornment, Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import InfoIcon from '@material-ui/icons/Info'
const colorError = '#EC4C47'

const useStylesBootstrap = makeStyles(theme => ({
   arrow: {
      color: colorError
   },
   tooltip: {
      backgroundColor: colorError
   }
}))

const BootstrapTooltip = props => {
   const classes = useStylesBootstrap()

   return <Tooltip placement="top" arrow classes={classes} {...props} />
}

export default function TooltipInputError(props) {
   return (
      <BootstrapTooltip title={props.title}>
         <InputAdornment position="end">
            <IconButton
               aria-label="toggle password visibility"
               style={{ color: colorError }}
            >
               <InfoIcon fontSize="small" />
            </IconButton>
         </InputAdornment>
      </BootstrapTooltip>
   )
}
